export default __webpack_public_path__ + "static/media/featured-bg-min.dab9be52.png";